import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgAnd } from '../../fg-math.js';

const bitwiseAndDef = {
  type: FgBlockType.BitwiseAnd,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any), sockIn("b", FgType.Any)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    const a = getDataValue(ctx, env, block, "a");
    const b = getDataValue(ctx, env, block, "b");
    setDataValue(ctx, block, "value", fgAnd(a, b));
  }
};

export { bitwiseAndDef };
//# sourceMappingURL=bitwise-and.js.map
